import { gql } from "@apollo/client";

import {
  ListTagsQuery,
  ListTagsWithIntegrationsQuery,
} from "~frontend/__generated__/graphql";

export const LIST_TAGS = gql`
  query listTags($input: ListTagsInput!) {
    listTags(input: $input) {
      totalCount
      tags {
        id
        name
      }
    }
  }
`;

const TAG_DETAIL_FIELDS = gql`
  fragment TagDetailFields on Tag {
    id
    name
    integrationActions {
      id
      integration {
        id
        service
        name
      }
      ngpVanMyCampaignActions {
        __typename
        ... on NgpVanTagIntegrationActionApplyActivistCode {
          actionType
          activistCodeId
          activistCode {
            id
            activistCodeId
            name
          }
        }
        ... on NgpVanTagIntegrationActionApplyResultCode {
          actionType
          resultCodeId
          resultCodeName
        }
        ... on NgpVanTagIntegrationActionApplySurveyResponse {
          actionType
          surveyQuestionId
          surveyQuestion {
            id
            surveyQuestionId
            name
            responses {
              surveyResponseId
              name
            }
          }
          surveyResponseId
        }
      }
      ngpVanMyVotersActions {
        __typename
        ... on NgpVanTagIntegrationActionApplyActivistCode {
          actionType
          activistCodeId
          activistCode {
            id
            activistCodeId
            name
          }
        }
        ... on NgpVanTagIntegrationActionApplyResultCode {
          actionType
          resultCodeId
          resultCodeName
        }
        ... on NgpVanTagIntegrationActionApplySurveyResponse {
          actionType
          surveyQuestionId
          surveyQuestion {
            id
            surveyQuestionId
            name
            responses {
              surveyResponseId
              name
            }
          }
          surveyResponseId
        }
      }
    }
  }
`;

export const LIST_TAGS_WITH_INTEGRATIONS = gql`
  ${TAG_DETAIL_FIELDS}

  query listTagsWithIntegrations($input: ListTagsInput!) {
    listTags(input: $input) {
      totalCount
      tags {
        ...TagDetailFields
      }
    }
  }
`;

export const CREATE_TAG = gql`
  mutation createTag($input: CreateTagInput!) {
    createTag(input: $input) {
      id
      name
    }
  }
`;

export const EDIT_TAG = gql`
  ${TAG_DETAIL_FIELDS}

  mutation editTag($input: EditTagInput!) {
    editTag(input: $input) {
      ...TagDetailFields
    }

    editTag(input: $input) {
      id
      name
    }
  }
`;

export const DELETE_TAGS = gql`
  mutation deleteTags($input: DeleteTagsInput!) {
    deleteTags(input: $input) {
      success
    }
  }
`;

export type ListTagsTag = ListTagsQuery["listTags"]["tags"][number];
export type ListTagsWithIntegrationsTag =
  ListTagsWithIntegrationsQuery["listTags"]["tags"][number];
